import { z } from 'zod';
import { createFileRoute } from '@tanstack/react-router';

import { QuickStartPage } from '@/features/emr/pages/QuickStartPage';

const searchSchema = z.object({
  patientId: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/quick-start')({
  component: QuickStartPage,
  validateSearch: searchSchema,
  beforeLoad: () => ({
    breadcrumbs: [{ href: '/quick-start', title: 'Quick Start' }],
  }),
});
